import React from 'react';
import { Box } from '@material-ui/core';

import SurveyQuestions from 'components/views/surveys/questions';

const QuetionsForm = ({ form, handleChange, isSingleType }) => {
  return (
    <Box pt={4} pb={4}>
      <SurveyQuestions
        displayAddQuestion={!isSingleType}
        initialValue={form.questions}
        surveyName={form.name}
        onChange={handleChange('questions')}
      />
    </Box>
  );
};

export default QuetionsForm;
